import groupBy from 'lodash/groupBy';
import type { LegacySemesterViewModel } from '../../ViewModel/LegacySemesterViewModel.csharp';
import type { LegacySubjectViewModel } from '../../ViewModel/Subject/LegacySubjectViewModel.csharp';
import type { ProgramSemesterSubjects, StudySubject } from '~/Partials/StudySubjects/StudySubjects';

const mapSubjectToModel = (subject: LegacySubjectViewModel): StudySubject => ({
    name: subject.name,
    url: subject.url,
});

export const mapSemestersToModel = (semesters: LegacySemesterViewModel[]): ProgramSemesterSubjects[] =>
    semesters.map(semester => {
        const result = {
            subjects: [],
            specializations: [],
        } as ProgramSemesterSubjects;

        const groupedSubjects = groupBy(semester.subjects, s => s.specialization);

        Object.entries(groupedSubjects).forEach(([specialization, subjects]) => {
            specialization
                ? result.specializations.push({
                      name: specialization,
                      subjects: subjects.map(mapSubjectToModel),
                  })
                : (result.subjects = subjects.map(mapSubjectToModel));
        });

        return result;
    });
